// @flow
/* eslint-disable camelcase */

import React, { memo } from 'react';
import HTMLParser from 'client/utils/HTMLParser';
import history from 'client/utils/history';
import secondsToTime from 'client/utils/secondsToTime';
import truncateString from 'client/utils/truncateString';
import Styles from './styles';
// import HDIcon from './assets/hd-icon.png';

type Props = {
  data : {
    uid : string,
    movie_title : string,
    movie_title_en : string,
    movie_img_m : string,
    serial : {
      enable : boolean,
      season_id : number,
    },
    HD : boolean,
    serial_season : number,
  },
  size : number,
};

export default memo(({ data, size } : Props) => {
  const getDuration = window.durationStorage[data.uid];
  return (
    <Styles
      {...{
        className: 'item videoItem selectableItem',
        route: `/v/${data.uid}`,
        size,
        onClick: () => history.push(`/v/${data.uid}`),
      }}
    >
      <div className="itemImageWrapper" style={{ backgroundImage: `url(${data.small_poster})` }}>
        <span className="duration">{secondsToTime(data.duration)}</span>
        {getDuration && (
          <div className="progressBar">
            <div
              className="percent-prograss"
              style={{ width: `${((getDuration / data.duration) * 100)}%` }}
            />
          </div>
        )}
      </div>
      <div className="itemContentWrapper">
        <h5 className="title">{HTMLParser(truncateString(data.title, 36))}</h5>
        <div className="info">
          <span className="date">{data.date_exact}</span>
          <span className="visit">{`${data.visit_cnt} بازدید`}</span>
        </div>
        <span className="author">{data.sender_name}</span>
      </div>
    </Styles>
  );
});
